export const DESKTOP_BREAKPOINT = 1023;
export const EVENTS = {
    VIEWPORT_CHANGE: 'seabreeze-viewport-change',
    NAVIGATION_CLOSE: 'seabreeze-navigation-close',
}
